import React, { useEffect, useState } from 'react';
import { ethers } from "ethers";
import { useLocation } from 'react-router-dom';

// Constants
// const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT
// const RECIPIENT_ADDRESS = "YOUR_WALLET_ADDRESS"; // Your wallet to receive USDT
// // Constants
// const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT
// const USDT_ABI = [
//     "function transfer(address to, uint256 amount) public returns (bool)",
//     "function balanceOf(address account) external view returns (uint256)",

// ];

const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT contract on BSC
const USDT_ABI = [
    "function transfer(address to, uint256 amount) public returns (bool)",
    "function balanceOf(address account) external view returns (uint256)"
];

// Replace with the BSC RPC URL (you can use BSC's public RPC or any other provider like QuickNode or Ankr)
const BSC_PROVIDER_URL = "https://bsc-dataseed.binance.org/"; // BSC public RPC

const WithdrawalReqRes = () => {

    const location = useLocation();
    const [requestDetails, setRequestDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const encryptedData = params.get('withdrawal_request_id');

        getWalletRequestDetails(encryptedData);
    }, [location]);

    useEffect(() => {
        if (requestDetails !== null) {
            // alert(JSON.stringify(requestDetails));
            // alert(requestDetails.amount);
            // return;
            depositUSDT(requestDetails);
        }
    }, [requestDetails]);

    const getWalletRequestDetails = async (id) => {
        try {
            // const response = await fetch("http://192.168.1.15/ecom/prometa/api/controller/api-controller/withdrawal-details", {
            const response = await fetch("https://prometajp.com/api/controller/api-controller/withdrawal-details", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ withdrawal_request_id: id }),
            });
            // alert(response.status);
            if (response.status === 200) {
                const data = await response.json();
                setRequestDetails(data?.lastCallData[0]);
                 

                // console.log("Transaction saved:", data);
                // alert("Transaction saved to the database!");
            }
        }
        catch (error) {
            console.error("Error saving transaction:", error);
        }
    }

    // console.log(requestDetails);

    const depositUSDT = async (requestDetails) => {
        // if (!window.ethereum) {
        //     alert("Please install a wallet like MetaMask to proceed!");
        //     return;
        // }

        // alert(JSON.stringify(requestDetails)); return;
        try {
            // Initialize BSC provider and signer

            // Switch to Binance Smart Chain if not already connected

            const provider = new ethers.BrowserProvider(window.ethereum);
            // const provider = new ethers.JsonRpcProvider("https://bsc-dataseed.binance.org/");
            const chainId = await window.ethereum.request({ method: 'eth_chainId' });
            if (chainId !== '0x38') { // 0x38 is the chainId for BSC
                alert("Please switch your wallet to Binance Smart Chain");
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: '0x38' }] // Switch to BSC
                });
                // return;
            }
            const signer = await provider.getSigner();
            // alert(JSON.stringify(signer)); return;

            // Connect to the USDT contract
            const usdtContract = new ethers.Contract(USDT_CONTRACT_ADDRESS, USDT_ABI, signer);
            const amountInWei = ethers.parseUnits(requestDetails.amount.toString(), 18);
            // alert(amountInWei); return;
            // Check admin wallet USDT balance
            const adminBalance = await usdtContract.balanceOf(signer.address);
            if (ethers.toBigInt(adminBalance) < ethers.toBigInt(amountInWei)) {
                alert("Insufficient USDT balance in the admin wallet.");
                return;
            }
            // Execute the transaction
            const tx = await usdtContract.transfer(requestDetails.receiver_wallet_address, amountInWei);

            // Wait for the transaction confirmation
            alert("Transaction submitted, waiting for confirmation...");
            const receipt = await tx.wait();

            // Notify the user of success

            // Optionally: Save transaction data to backend
            await saveTransaction(receipt.transactionHash, signer.address);

        } catch (error) {
            alert("Transaction failed! Ensure you have enough USDT and BNB for gas fees.");
            alert(error);
        }
    };

    const saveTransaction = async (txHash, adminWallet) => {
        try {
            const transactionData = {
                ...requestDetails,
                tx_hash: txHash,
                payee_wallet_address: adminWallet,
            }
            // alert(JSON.stringify(transactionData));

            // const response = await fetch("http://192.168.1.15/ecom/prometa/api/controller/api-controller/save-withdrawal-transaction", {
            const response = await fetch("https://prometajp.com/api/controller/api-controller/save-withdrawal-transaction", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(transactionData),
            });

            //alert(response.status);
            // if (response.status === 200) {
                alert("Transaction Successful!");
                // const data = await response.text();
                setIsLoading(false);
                // alert("data :", data);
                window.location.replace(`https://prometajp.com/api/admin/withdraw-request-list.php`);
                // window.location.replace(`http://192.168.1.15/ecom/prometa/api/admin/withdraw-request-list.php`);                
                // console.log("Transaction saved:", data);
                // alert("Transaction saved to the database!");
            // }
        }
        catch (error) {
            //console.error(error);
            alert(JSON.stringify(error));
        }
    }


    return (
        <h1>Sending amount to the wallet</h1>
    )
}

export default WithdrawalReqRes;